import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const UploadDonationsModalContext = createContext<ContextType | null>(null);

const UploadDonationsModalProvider: ComponentWithChildren = ({ children }) => {
  const providerValue = useProviderValue();

  return (
    <UploadDonationsModalContext.Provider value={providerValue}>
      {children}
    </UploadDonationsModalContext.Provider>
  );
};

export const useUploadDonationsModalContext = () => {
  const context = useContext(UploadDonationsModalContext);
  if (!context) {
    throw new Error(
      'the useUploadDonationsModalContext should be used within UploadDonationsModalProvider!'
    );
  }

  return context;
};

export default UploadDonationsModalProvider;
